import classes from "./CartItem.module.css";
import { plusIcon, minusIcon } from "../../utility-functions/assetLoader";
import { CustomTooltip } from "../design/components/customComponents";
import { useNavigate } from "react-router-dom";
import { currencyFormatter } from "../../utility-functions";

const CartItem = ({
  icon,
  name,
  description,
  price,
  discountedPrice,
  quantity = 0,
  onIncrement,
  onDecrement,
  currency,
  assignedLicenses,
  from,
  showChangePlan,
  handleChangePlan = () => null
}) => {
  const navigate = useNavigate();
  const isDisabledDueToAssignment =
    quantity > 0 && assignedLicenses > 0 && quantity <= assignedLicenses;
  const isDisabledDueToMinPlan =
    name?.toLowerCase()?.includes("plan") &&
    quantity === 1;

  const isDisabled =
    quantity <= 0 || (from === 'reactivate' && (isDisabledDueToAssignment || isDisabledDueToMinPlan));

  const decrementButton = (
    <button
      className={classes.pickerBtn}
      onClick={onDecrement}
      disabled={isDisabled}
      style={{ borderRadius: "6px 0 0 6px" }}
    >
      {minusIcon("20", "20", isDisabled ? "#E4E4E7" : "#3F3F46")}
    </button>
  );

  return (
    <div className={classes.cartItem}>
      <div className={classes.topSection}>
        {icon && (
          <div className={classes.iconContainer}>
            {typeof icon === "string" ? <img src={icon} alt={name} /> : icon}
          </div>
        )}
        <div className={classes.textContent}>
          <h4 className={classes.itemName}>{name}</h4>
          <p className={classes.itemDescription}>{description}</p>
        </div>
        {showChangePlan && (
          <button className={classes.changePlanBtn} onClick={handleChangePlan}>Change plan</button>
        )}
      </div>
      <div className={classes.bottomSection}>
        <div className={classes.priceContainer}>
          {Number(price) > Number(discountedPrice) && (
            <span className={classes.oldPrice}>
              {currencyFormatter(currency, price)}
            </span>
          )}
          <span className={classes.currentPrice}>
            {currencyFormatter(currency, discountedPrice)}
          </span>
          <span className={classes.priceUnit}>/license/mo</span>
        </div>
        <div className={classes.quantityActions}>
          <span className={classes.licensesLabel}>Licenses</span>
          <div className={classes.quantityPicker}>
            {from === 'reactivate' && (isDisabledDueToAssignment || isDisabledDueToMinPlan) ? (
              <CustomTooltip
                placement="top"
                tooltipTitle={
                  <div className={classes.tooltipContent}>
                    <p className={classes.tooltipText}>
                      {isDisabledDueToAssignment
                        ? "All licenses are currently assigned. Unassign a license first to remove it."
                        : "Minimum 1 license is required."}
                    </p>
                   {isDisabledDueToAssignment && (
                      <span
                        className={classes.tooltipLink}
                        onClick={() => navigate("/users-and-teams")}
                      >
                        View Assigned Users
                      </span>
                    )}
                  </div>
                }
              >
                {decrementButton}
              </CustomTooltip>
            ) : (
              decrementButton
            )}
            <span className={classes.quantityValue}>{quantity}</span>
            <button
              style={{ borderRadius: "0 6px 6px 0" }}
              className={classes.pickerBtn}
              onClick={onIncrement}
            >
              {plusIcon("#3F3F46", "20", "20")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
